// Ebook UI labels. Unlike the glossary, the ebook section has no Strapi settings
// single-type — the label set is small and fixed, so defaults live here.
export const EBOOK_LABELS = {
  homeLabel: 'Domů',
  breadcrumbAriaLabel: 'Navigace',
  heroEyebrow: 'Průvodce',
  tocTitle: 'Obsah průvodce',
  furtherReadingTitle: 'Další zdroje ke studiu',
  newsletterPlaceholder: 'Váš e-mail',
  newsletterButtonLabel: 'Přihlásit se',
  newsletterSubmittedText: 'Děkujeme! Máte to.'
};

export const getEbookLabels = () => EBOOK_LABELS;

export const useEbookLabels = () => EBOOK_LABELS;
